export default __webpack_public_path__ + "static/media/comment-alt-solid.7df3f00f.svg";